import { render, staticRenderFns } from "./SettlementsList.vue?vue&type=template&id=e5b5c04e&"
import script from "./SettlementsList.vue?vue&type=script&lang=js&"
export * from "./SettlementsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports